import { useState, useCallback, useRef } from "react";
import { extractPlainText } from "../utils/exportUtils";
import { convertTextToHtml } from "../utils/textProcessing";

/**
 * useResponses - Custom hook for managing response state and formatting
 * @returns {Object} { responses, setResponses, getResponsePlain, getResponseHtml }
 */
export function useResponses() {
  const [responses, setResponses] = useState({});
  const htmlCacheRef = useRef({});

  const getResponsePlain = useCallback((data) => {
    if (!data) return "";
    if (data.formatted) {
      return extractPlainText(data.formatted);
    }
    return data.text || "";
  }, []);

  const getResponseHtml = useCallback((model) => {
    const data = responses[model];
    if (!data) return "";

    if (data.formatted) {
      return data.formatted.replace(/\*/g, "");
    }

    const text = data.text || "";
    const cached = htmlCacheRef.current[model];
    if (cached && cached.text === text) {
      return cached.html;
    }

    const html = convertTextToHtml(text);
    htmlCacheRef.current[model] = { text, html };
    return html;
  }, [responses]);

  return {
    responses,
    setResponses,
    getResponsePlain,
    getResponseHtml
  };
}

